import './navigation';
import { Fancybox } from "@fancyapps/ui";

(function($) {
	$(document).ready(function() {
		Fancybox.bind("[data-fancybox='referenzen']", {
			Thumbs: {
				autoStart: true
			},
			Toolbar: {
				display: [
					{ id: "prev", position: "center" },
					{ id: "counter", position: "center" },
					{ id: "next", position: "center" },
					"close"
				]
			},
			animated: true,
			dragToClose: true,
			groupAll: true, // sorgt dafür, dass alle Bilder als Gruppe geöffnet werden
			compact: false,
		});
	});
})(jQuery);
